import { useReadPlayerBaseInfo } from '@/scenarios/legacy-player/components/player-manager/hooks/use-read-player-base-info';
import { transformGqlToAgeRestriction } from '@/scenarios/legacy-player/lib/transform-age-restriction';

export function useFilmAgeRestriction(contentId: string): string | undefined {
    const data = useReadPlayerBaseInfo(contentId);
    const content = data?.content;

    if (content?.__typename !== 'Film' && content?.__typename !== 'Video') {
        return undefined;
    }

    const ageRestriction = content.restriction?.age;

    return ageRestriction ? transformGqlToAgeRestriction(ageRestriction) : undefined;
}
